/* eslint-disable no-func-assign */
import { FC } from "react";
import styles from "./ItemsList.module.css";
import Card from "../Card/Card";
import useWindowSize from "../../hooks/useWindowSize";
import { cardWidth } from "../../utils/layoutUtils";
import { SaleItemDb } from "../../models/sale-item.db";
import { UserDb } from "../../models/user.db";

interface Props {
  items: Array<SaleItemDb>;
  users: Array<UserDb>;
  indyxUser: UserDb | null;
  onClick: (item: SaleItemDb) => void;
  onShowModal: () => void;
  emptyString: string;
}
const ItemsList: FC<Props> = ({
  items,
  users,
  indyxUser,
  onClick,
  onShowModal,
  emptyString,
}) => {
  const windowSize = useWindowSize();
  const width = cardWidth(windowSize.width);
  return (
    <div className={styles.listCards}>
      {items.length ? (
        items.map((item) => {
          return (
            <Card
              key={item.id}
              onClick={onClick}
              item={item}
              user={users.find((u) => u.id === item.userId) ?? null}
              indyxUser={indyxUser}
              width={width}
            />
          );
        })
      ) : (
        <div
          style={{
            width: "100%",
            height: "50vh",
            display: "flex",
            alignSelf: "center",
            justifySelf: "center",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {emptyString}
        </div>
      )}
    </div>
  );
};
export default ItemsList;
